import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';
import NavItem from './NavItem';
import MobileMenu from './MobileMenu';
import { FiMenu, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../../assets/images/logo3.png';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <motion.header
            className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ type: 'spring', stiffness: 100, damping: 15 }}
        >
            <div className={styles.topBar}>
                <div className={styles.container}>
                    <div className={styles.topBarContent}>
                        <div className={styles.topBarText}>
                            Türkiye'nin En Hızlı Fiber İnternet Kampanyaları
                        </div>
                        <div className={styles.topBarContact}>
                            <a href="tel:+908508079898" className={styles.phoneLink}>
                                📞 0850 807 98 98
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.mainHeader}>
                <div className={styles.container}>
                    <Link to="/" className={styles.logoWrapper}>
                        <motion.img
                            src={logo}
                            alt="NetKampanya Logo"
                            className={styles.logoImage}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        />
                    </Link>

                    <nav className={styles.desktopNav}>
                        <ul className={styles.navList}>
                            <NavItem path="/" exact>
                                <div className={styles.navItemContent}>
                                    Ana Sayfa
                                </div>
                            </NavItem>
                            <NavItem path="/kampanyalar">
                                <div className={styles.navItemContent}>
                                    Kampanyalar
                                </div>
                            </NavItem>
                            <NavItem path="/hiz-testi">Hız Testi</NavItem>
                            <NavItem path="/iletisim">İletişim</NavItem>
                        </ul>
                    </nav>

                    <div className={styles.headerActions}>
                        <motion.a
                            href="tel:+908508079898"
                            className={styles.ctaButton}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <span className={styles.ctaIcon}>📞</span>
                            Hemen Ara
                        </motion.a>
                    </div>

                    <motion.button
                        className={styles.mobileMenuButton}
                        onClick={toggleMobileMenu}
                        aria-label="Menüyü Aç/Kapat"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        {isMobileMenuOpen ? (
                            <FiX size={24} />
                        ) : (
                            <FiMenu size={24} />
                        )}
                    </motion.button>
                </div>
            </div>

            <AnimatePresence>
                {isMobileMenuOpen && (
                    <MobileMenu
                        isOpen={isMobileMenuOpen}
                        onClose={toggleMobileMenu}
                    />
                )}
            </AnimatePresence>
        </motion.header>
    );
};

export default Header;